import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext'; // IMPORTS THE HOOK

const Footer = () => {
    // State to manage the current theme
    const { theme, setTheme, activeIconSvg } = useTheme(); // GETS THEME AND SETTER FROM CONTEXT

    // Helper to calculate the position of the theme indicator
    const getIndicatorPosition = () => {
        const positions = { light: '2px', dark: '31px', system: '60px' };
        return { transform: `translateX(${positions[theme]})` };
    };

    return (
        <footer className="mt-auto py-4 px-8 flex items-center justify-between border-t border-gray-300/50 dark:border-[#2A2A2A]/50">
            {/* =================================================================
            == THEME TOGGLE SECTION
            ================================================================= */}
            <div className="flex items-center space-x-4">
                <div className="relative inline-flex items-center rounded-full bg-gray-100 dark:bg-[#1F1F1F] h-7 border border-gray-300 dark:border-[#2A2A2A] transition-all duration-300">
                    {/* Light Mode Button */}
                    <div className="relative group">
                        <button onClick={() => setTheme('light')} className="w-7 h-7 flex items-center justify-center cursor-pointer" aria-label="Switch to light theme">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-gray-700 dark:text-[#808080]"><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" /></svg>
                        </button>
                    </div>
                    {/* Dark Mode Button */}
                    <div className="relative group">
                        <button onClick={() => setTheme('dark')} className="w-7 h-7 flex items-center justify-center mx-px cursor-pointer" aria-label="Switch to dark theme">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-gray-700 dark:text-[#808080]"><path strokeLinecap="round" strokeLinejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" /></svg>
                        </button>
                    </div>
                    {/* System Mode Button */}
                    <div className="relative group">
                        <button onClick={() => setTheme('system')} className="w-7 h-7 flex items-center justify-center cursor-pointer" aria-label="Switch to system theme">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-gray-700 dark:text-[#808080]"><path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25A2.25 2.25 0 015.25 3h13.5A2.25 2.25 0 0121 5.25z" /></svg>
                        </button>
                    </div>
                    {/* Dynamic Indicator. This div now contains a self-rendering SVG */}
                    <div
                        className="absolute w-6 h-6 bg-white dark:bg-[#D9D9D9] rounded-full shadow-sm transition-transform duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] flex items-center justify-center"
                        style={getIndicatorPosition()}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.8"
                            stroke="currentColor"
                            className="w-4 h-4"
                            dangerouslySetInnerHTML={{ __html: activeIconSvg }}
                        />
                    </div>
                </div>
            </div>

            {/* =================================================================
            == FOOTER LINKS SECTION
            ================================================================= */}
            <div className="flex space-x-4">
                <Link to="/about" className="text-sm text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-[#7DD3FC] transition-colors duration-200">About</Link>
                <Link to="/blog" className="text-sm text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-[#7DD3FC] transition-colors duration-200">Blog</Link>
                <Link to="/changelog" className="text-sm text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-[#7DD3FC] transition-colors duration-200">Changelog</Link>
                <Link to="/terms-of-service" className="text-sm text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-[#7DD3FC] transition-colors duration-200">Terms of Service</Link>
                <Link to="/contact" className="text-sm text-gray-900 dark:text-gray-100 hover:text-blue-600 dark:hover:text-[#7DD3FC] transition-colors duration-200">Contact</Link>
            </div>

            {/* =================================================================
            == COPYRIGHT SECTION
            ================================================================= */}
            <div className="text-sm text-gray-600 dark:text-[#A3A3A3]">© Trueway</div>
        </footer>
    );
};

export default Footer;